
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 38 32","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"38","height":"32","data-name":"Vector Smart Object","xlink:href":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAgCAQAAADUbcI4AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfkBwcLGS9Scmw9AAAC90lEQVRIx52WW0iUQRTH/2ul6ba1SorZvQhRozaiIlq6CqUQRJRE9CBiD5VQEFFYBNZL9FC9FBaVZRRBD0lRSWZCQUUhXcxL2sXcpMwQ0zQv6a+H1nV3v9393M68nDln5jfzzZlz5hMyaUsYkiVmYy3IRCK0SFZJXXqhwdBDR4fwpWiL1miBYtz9br1Uua6rNvi6gcWpclVruUq0TomKUpQStU4lWq5qlWtZkFkBvt1GMf0UMsPPnslWYplBIf0UYzPONKLmUM8r5gZYJI8meihiNnN5RT1zzGAptHKNqCDxsrCCUno5RAzXaCUlFCwBF0VYTK5AJt+4i5UiXCQEg1koo4JRpjdPTKaKcqJ5SJn30t5Dsmln0ghQQsTzkUIm0U52IFgkTewaIUqI+dxD7KKJSCMsm+Zh84jaRE4RRfPw3oZdFRwNCyVsdLGGo1T4w+z8wREmTFykGAd/sPvC0mkzvRLGtokvWGgj/V9/KDfTVCXTAmKQMj2TVKW0oaoRo0hJ0/VD9rBhUq4m6Iemyy6pz0KHbP8BCSSdFuJlDeqO0EItVoL69EEVajGBdRkPNYJ0nAixihp+U0YhV6lmgNusD51svt2ZFNDIAE2MpoB+jhHr8Tk4QwcuCrB6bNE4mRUItpGHwBNySeIXb2hhlce3mKUIYSWHWm4gxpDBFX7RzSDbjbDX3CfZrV/iM0leO95HHzXsIQ6RQRen+U4Hl1nLKHbgMsLyee7RV9PNeL883Ms7erjBW3q5SRbRbs8B6o2wqQyS6glCI7mGA7awghMcHEoebOzkNd1sCBSABxz36Ed4HDKRHJylk0/ke9da7wHb+OoJ/WwG2c1KEg2YsWTzlAFukUmEr8/7RY/RN2Wp1N17pAVCNv1UrepUp/dqV5Kc2qweXdA5uYy31vf34LzGaYtbz9FhzVKSkpWqZKVomsbruypVojvqD5IDPht10oMdMYV8Gvjt+/aYN/94NXCBUgaoJI+4cOubv2E/rZxkXthlUgj9BdSRJBT0Gqf1AAAAAElFTkSuQmCC"}})])
          )
        }
      }
    